import { PlottableModel,Transform,TransformGroup  } from './4d-objects';
import { MapHelper } from './4d-helper';
import { Observable, from, Subject } from 'rxjs';
import { PlottableReference } from './renderer'
/**
 * <p>Helper class for <a href="https://leafletjs.com/">Leaflet</a>. Contains methods to zoom to a location and add/remove a model to the map.</p>
 * <p>You can play with a(n) (<a href="https://stackblitz.com/edit/angular-demo-leaflet">angular</a> or <a href="https://stackblitz.com/edit/react-demo-leaflet">react</a>) demo on stackblitz.</p>
 */
export class LeafletHelper extends MapHelper {
  private _objectCache: { [key: string]: any } = {}
  map

  constructor(map,private L:any) {
    super()
    this.map = map
  }

  getAuthenticatedUrl(p: PlottableModel<any>, file: string, tier: number = 0): Promise<string[]> {
    return fetch(p.file('DIRECT_TOKEN_URL') + '&tier=' + tier)
      .then(r => r.json())
      .then(r => {
        console.log('\n\n\nr: ', r, '\np: ', p.file('DIRECT_TOKEN_URL'))
        if (r.status == 200 && r.payload.url && r.payload.prefix) {
          var array = r.payload.url.split('?')
          array[0] += r.payload.prefix.substring(0, r.payload.prefix.length - 2) + '/' + file
          return array
        }
        return p.file(file).split('?')
      })
  }
  
  setPlottable(p: PlottableModel<any>, args?: any): Observable<PlottableReference> {
    var opts = {}
    if (p.transformType.uid == 'tms') {
      opts = { tms: true }
    }

    return from(this.getAuthenticatedUrl(p, '{z}/{x}/{y}.png').then(url => {
      var layer = this.L.tileLayer(url[0] + '?' + url[1], opts)
      layer.addTo(this.map)
      this._objectCache[this.keyFor(p)] = layer
      return { plottable: p, object: layer }
    }))
  }


  clearPlottables() {
    Object.keys(this._objectCache).forEach(k => this._objectCache[k].remove())
  }

  sendCameraTo(p: PlottableModel<any>, duration?: number, args?: any): Observable<any> {
    var zoom = 18
    var imageBounds = [[p.llat, p.llng], [p.ulat, p.ulng]]
    this.map.flyToBounds(imageBounds, zoom)

    var delaySubject = new Subject()
    setTimeout(() => delaySubject.next(this.map), duration + 100)
    return delaySubject.asObservable()
  }

  getMapObjectFor(p: PlottableModel<any>) {
    return this._objectCache[this.keyFor(p)]
  }

  changeOpacity(t: Transform, opacity?: number){
    throw new Error("Not yet supported")
  }

 resolveItem(movement):PlottableModel<any>{
   throw new Error("Not yet supported")
 }
  /**
   * <p>Generate unique string key for [[PlottableModel]].</p>
   * @param p Uses the [[PlottableModel]]'s classname and id to generate key
   */
  private keyFor(p: PlottableModel<any>): string {
    return '_' + p.className() + '_' + p.id
  }
}